import type { Avatar } from '@sokdaq/protocol';

/**
 * 아바타 팔레트.
 *
 * 직접 고르지 않았으면 닉네임에서 결정적으로 뽑는다. 같은 사람이 늘 같은
 * 색으로 보이는 편이 알아보기 쉽고, 무작위로 뽑으면 재입장할 때마다
 * 남처럼 보인다. M5의 커스터마이즈 UI는 이 팔레트 안에서만 고르게 한다 —
 * 자유 색상은 배경에 묻히거나 살색 대신 형광색을 고르게 된다.
 */
export const SKINS = ['#f0c8a0', '#e0ac81', '#c68863', '#8d5524', '#ffdbac'];
export const HAIRS = ['#2c1b18', '#3a2a1a', '#5a3825', '#8b4513', '#1a1a1a', '#6b4423'];
export const TOPS = ['#4a6fa5', '#a54a4a', '#4aa563', '#8a4aa5', '#a5904a', '#4a9aa5', '#555b6e'];

export function avatarFor(nickname: string): Avatar {
  const hash = fnv1a(nickname);
  return {
    sprite: 'default',
    skin: SKINS[hash % SKINS.length]!,
    hair: HAIRS[(hash >>> 5) % HAIRS.length]!,
    top: TOPS[(hash >>> 11) % TOPS.length]!,
  };
}

/** FNV-1a. 암호학적 용도가 아니라 색을 고르기만 한다. */
function fnv1a(input: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}
